import { z } from "zod/v4";

export const GetAISuggestionsRequestBodySchema = z.object({
  message: z.string().optional(),
});

export const AISuggestedTestIdeaSchema = z.object({
  title: z.string(),
  currentText: z.string(),
  description: z.string(),
  suggestions: z.array(z.string()).default([]),
  cssSelectors: z.array(z.string()).default([]),
});

export type AISuggestedTestIdeaType = z.infer<typeof AISuggestedTestIdeaSchema>;

export const GetAISuggestionsResponseBodySchema = z.object({
  testIdeas: z.array(AISuggestedTestIdeaSchema),
});

export type GetAISuggestionsRequestBodyType = z.infer<
  typeof GetAISuggestionsRequestBodySchema
>;

export type GetAISuggestionsResponseBodyType = z.infer<
  typeof GetAISuggestionsResponseBodySchema
>;
